module.exports = __webpack_public_path__ + "img/fy8.6dddf9d1.jpg";